export default [{
        username: "Prime Blogs",
        date: "2023.01.01",
        link: "https://prmblogs.tistory.com/5",
        profile: "https://tistory1.daumcdn.net/tistory/5878727/attach/cc3e9f7f252c43ed8768b5a1b83623ad",
        title: " VuejS vs Tailwind CSS ",
        image: "https://placeimg.com/300/200/archhttps://img1.daumcdn.net/thumb/R750x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FbM2IEB%2FbtrU38Cp9GV%2FtVzE4j0D9VY7qbqKAABIy0%2Fimg.jpg",
        intro: "Tailwind CSS 설치 및 VUEJS 프로젝트 적용하는 방법",
    },

    {
        username: "Prime Blogs",
        date: "2022.12.30",
        link: "https://prmblogs.tistory.com/4",
        profile: "https://tistory1.daumcdn.net/tistory/5878727/attach/cc3e9f7f252c43ed8768b5a1b83623ad",

        title: "VueJs List Rendering",
        image: "https://img1.daumcdn.net/thumb/R750x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FdNu4Zm%2FbtrUVkpGuUd%2Fx41U7clwnGukxCQW25STsK%2Fimg.png",

        intro: "VueJs List Rendering [ 리스트 렌더링 ] 하는 법",
    },

    {
        username: "Prime Blogs",
        date: "2022.12.26",
        link: "https://prmblogs.tistory.com/2",

        profile: "https://tistory1.daumcdn.net/tistory/5878727/attach/cc3e9f7f252c43ed8768b5a1b83623ad",

        title: "Vuejs Firebase 연동 ",
        image: "https://placeimg.com/300/200/archhttps://img1.daumcdn.net/thumb/R750x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FbM2IEB%2FbtrU38Cp9GV%2FtVzE4j0D9VY7qbqKAABIy0%2Fimg.jpg",

        intro: "Vuejs Firebase 연동 오류 해결 v9버전, 2023 [solved ]",
    },

    {
        username: "Prime Blogs",
        date: "2023.01.02",
        link: "https://prmblogs.tistory.com/5",
        profile: "https://tistory1.daumcdn.net/tistory/5878727/attach/cc3e9f7f252c43ed8768b5a1b83623ad",

        title: "VUe 알림장창 만들기 ",
        image: "https://miro.medium.com/max/828/0*L2GGz8fwNA_IZcFb.webp",

        intro: "V-If 사용해 Vue에서 동적인 UI 만드는 법)",
    },
];